import { TraitsResultProps, useEditor } from "@grapesjs/react";
import { Package } from "@hl/base-components/lib/assets/icons/HDS";
import { Box, Divider, Group, Stack, Text } from "@mantine/core";

import { CustomTraitPropertyField } from "./CustomTraitPropertyField";

export const CustomTraitManager = ({
  traits,
}: Omit<TraitsResultProps, "Container">) => {
  const editor = useEditor();

  const selectedComponent = editor.getSelected();

  if (selectedComponent == null) {
    return (
      <Box py={"sm"}>
        <Text size={"lg"}>Select a component</Text>
      </Box>
    );
  }

  return (
    <Stack py={"sm"} spacing={0}>
      <Stack spacing={4} p={"xs"}>
        <Text size={"xs"} c={"dimmed"}>
          selected
        </Text>
        <Group noWrap spacing={"sm"}>
          <Package
            height={20}
            width={20}
            style={{
              flexShrink: 0,
            }}
          />
          <Text size={"lg"}>{selectedComponent.getName()}</Text>
        </Group>
      </Stack>

      {/* <Text size={"sm"} c={"dimmed"} ta={"center"} pt={"md"}>
        Settings
      </Text> */}

      {traits.length > 0 && (
        <Stack p={12}>
          {traits.map((trait) => (
            <CustomTraitPropertyField key={trait.getId()} trait={trait} />
          ))}
        </Stack>
        // <Accordion
        //   styles={{
        //     control: {
        //       padding: "16px 10px",
        //     },
        //     label: {
        //       fontWeight: 500,
        //     },
        //     content: {
        //       padding: "0",
        //     },
        //   }}
        // >
        //   <Accordion.Item key={"settings"} value={"settings"}>
        //     <Accordion.Control>Settings</Accordion.Control>
        //     <Accordion.Panel>
        //       <Stack p={12}>
        //         {traits.map((trait) => (
        //           <CustomTraitPropertyField key={trait.getId()} trait={trait} />
        //         ))}
        //       </Stack>
        //     </Accordion.Panel>
        //   </Accordion.Item>
        // </Accordion>
      )}

      <Divider />
    </Stack>
  );
};
